import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfLabours
export const getBillOfLabour = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-labour:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfLabour
export const getBillOfLabourById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching billOfLabour:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfLabour
export const createBillOfLabour = async (billOfLabourData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-labour`, billOfLabourData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-labour:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfLabour
export const updateBillOfLabour = async (id, billOfLabourData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-labour/${id}`, billOfLabourData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-labour:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfLabour
export const deleteBillOfLabour = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-labour/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-labour:", error.response?.data || error);
    throw error;
  }
};

// GET billOfLabour by taskId
export const getBillOfLabourByTaskId = async (taskId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-labour`, {      params: { taskId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-labour:', error.response?.data || error);
    throw error;
  }
};
